import { render } from "./CCS-pjfy.vue?vue&type=template&id=50aa8f7a&scoped=true"
import script from "./CCS-pjfy.vue?vue&type=script&lang=js"
export * from "./CCS-pjfy.vue?vue&type=script&lang=js"

import "./CCS-pjfy.vue?vue&type=style&index=0&id=50aa8f7a&scoped=true&lang=css"

import exportComponent from "F:\\MyProject\\8.142.129.201\\FCS\\admin\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50aa8f7a"]])

export default __exports__